<div class="split-login-container" #containerRef>
  <!-- ════════════════════════════════════════════════════════════
       PANEL IZQUIERDO: ARTE VAGABOND / MUSASHI (SUMI-E)
       ════════════════════════════════════════════════════════════ -->
  <aside class="samurai-showcase" aria-hidden="true">
    <!-- Lienzo de partículas de brasa y niebla de tinta (30 FPS) -->
    <canvas #atmosphereCanvas class="atmosphere-canvas"></canvas>

    <!-- Resplandor tenue rojo carmesí -->
    <div class="crimson-glow"></div>

    <!-- Contenedor del Arte de Musashi -->
    <div class="art-showcase-content">
      <!-- Marco Cuadrado de Exhibición Manga -->
      <div class="manga-art-frame">
        <img src="assets/img/musachi.png" alt="cris7ianback" class="musashi-img" />
      </div>

      <!-- Tipografía Editorial de Marca -->
      <h1 class="brand-title">cris7ianback</h1>
    </div>
  </aside>

  <!-- ════════════════════════════════════════════════════════════
       PANEL DERECHO: FORMULARIO DE ACCESO (DARK MINIMALIST)
       ════════════════════════════════════════════════════════════ -->
  <main class="auth-panel">
    <!-- Resplandor reactivo tenue al mover el cursor -->
    <div class="cursor-glow-backdrop"></div>

    <div class="auth-card">
      <!-- Encabezado con línea carmesí -->
      <header class="auth-header">
        <div class="crimson-bar"></div>
        <h2 class="auth-title">Iniciar Sesión</h2>
        <p class="auth-subtitle">Introduce tus credenciales para continuar</p>
      </header>

      <!-- Formulario -->
      <form novalidate #loginForm="ngForm" (ngSubmit)="onSubmit()" class="auth-form">
        <!-- Usuario -->
        <div class="form-group">
          <label for="username" class="field-label">Usuario</label>
          <div class="input-container">
            <i class="fas fa-user input-icon"></i>
            <input
              id="username"
              name="username"
              type="text"
              class="auth-input"
              placeholder="Introduce tu usuario"
              required
              minlength="3"
              autocomplete="username"
              autocapitalize="none"
              autocorrect="off"
              spellcheck="false"
              [(ngModel)]="username"
            />
          </div>
        </div>

        <!-- Contraseña -->
        <div class="form-group">
          <label for="password" class="field-label">Contraseña</label>
          <div class="input-container">
            <i class="fas fa-lock input-icon"></i>
            <input
              id="password"
              name="password"
              [type]="hidePassword ? 'password' : 'text'"
              class="auth-input"
              placeholder="••••••••••••"
              required
              minlength="6"
              autocomplete="current-password"
              autocapitalize="none"
              autocorrect="off"
              spellcheck="false"
              [(ngModel)]="password"
            />
            <button
              type="button"
              class="btn-toggle-eye"
              (click)="hidePassword = !hidePassword"
              [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
              tabindex="-1"
            >
              <i class="fas" [ngClass]="hidePassword ? 'fa-eye' : 'fa-eye-slash'"></i>
            </button>
          </div>
        </div>

        <!-- Botón de Envío -->
        <button
          type="submit"
          class="auth-submit-btn"
          [disabled]="!loginForm.form.valid || loadingService.isLoading()"
        >
          <ng-container *ngIf="!loadingService.isLoading()">
            <span>Ingresar</span>
            <i class="fas fa-arrow-right btn-arrow"></i>
          </ng-container>
          <ng-container *ngIf="loadingService.isLoading()">
            <span class="btn-spinner"></span>
            <span>Verificando...</span>
          </ng-container>
        </button>
      </form>
    </div>
  </main>
</div>